define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/query",
	"dijit/_TemplatedMixin",
	"dijit/_Widget",
	"csi/html",
	"dojo/text!csi/widget/CommentColors.html"
], function(array,declare,domClass,query,_TemplatedMixin,_Widget,html,template) {

return declare([_Widget, _TemplatedMixin], {
		templateString: template,
		
		// String: make sure value is here even though it is not really used - it is needed to
		// be returned as widget from _getDescendantFormWidgets function
		value: "",
		
		_getValueAttr: function() {
			var	a = query(".active", this.domNode);
			if (a) {
				a = html.getClass(a[0]).split(" ");
				a = (a[0] == "active") ? a[1] : a[0];
				return (a == "commentColorDefault") ? "" : a;
			}
			
			return null;
		},
		
		_setValueAttr: function(/*String*/value) {
			value = value || "commentColorDefault";

			array.forEach(this.domNode.childNodes, function(e) {
				domClass.toggle(e, "active", domClass.contains(e, value));
			});
			
			//set tabindex to -1 to prevent default focusing
			$(this.domNode).attr("tabindex","-1");
		},

		__onClickColor: function(/*Event*/ evt){
			// summary: set active color class if clicked on image
			var	e = evt.target;
			
			if ((e.tagName.toLowerCase() == "span") && !domClass.contains(e, "active")) {
				this._setValueAttr(html.getClass(e));
			}
		}	
	});
});